import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=7ad4437a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4437a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad4437a')) {
      api.createRecord('7ad4437a', component.options)
    } else {
      api.reload('7ad4437a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=7ad4437a&scoped=true&", function () {
      api.rerender('7ad4437a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20YungjxTnnoC/JS/comp/Accordion.vue"
export default component.exports